var map = {
	"./Anhui-speed.png": "4437",
	"./Beijing-speed.png": "454e",
	"./Chongqing-speed.png": "5503",
	"./Fujian-speed.png": "8609",
	"./Gansu-speed.png": "0965",
	"./Guangdong-speed.png": "6483",
	"./Guangxi-speed.png": "61ea",
	"./Guizhou-speed.png": "2ebe",
	"./Hainan-speed.png": "5004",
	"./Hebei-speed.png": "8afe",
	"./Henan-speed.png": "c1f3",
	"./Hubei-speed.png": "7928",
	"./Hunan-speed.png": "ab28",
	"./Jiangsu-speed.png": "6fa3",
	"./Jiangxi-speed.png": "5ce5",
	"./Jilin-speed.png": "eb6e",
	"./Liaoning-speed.png": "dbb2",
	"./Nei Mongol-speed.png": "a846",
	"./Ningxia Hui-speed.png": "02f0",
	"./Qinghai-speed.png": "3a97",
	"./Shaanxi-speed.png": "66b4",
	"./Shandong-speed.png": "6fbb",
	"./Shanghai-speed.png": "5ad4",
	"./Shanxi-speed.png": "dfed",
	"./Sichuan-speed.png": "95fb",
	"./Tianjin-speed.png": "036d",
	"./Xinjiang Uygur-speed.png": "04fc",
	"./Xizang-speed.png": "6ff6",
	"./Yunnan-speed.png": "f15b",
	"./Zhejiang-speed.png": "976d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9adb";